module.exports = __webpack_public_path__ + "img/product01-5.d7416a8c.png";